import { memo } from 'react';
import styled, { css } from 'styled-components';

const BaseText = styled.p`
  text-transform: ${(props) => props.textTransform};
  color: ${(props) => props.color || props.theme.colors.blackText};

  font-weight: ${(props) => props.fw || 400};
  ${(props) => {
    switch (props.type) {
      // case 'small':
      //   return css`
      //     font-size: ${props.theme.typography.text.small.size};
      //     line-height: ${props.theme.typography.text.small.lineHeight};
      //   `;
      case 'big':
        return css`
          font-size: ${props.theme.typography.text.big.size};
          line-height: ${props.theme.typography.text.big.lineHeight};
        `;
      default:
        return css`
          font-size: ${props.theme.typography.text.default.size};
          line-height: ${props.theme.typography.text.default.lineHeight};
        `;
    }
  }}
`;

export default memo(BaseText);
